import { isTranscriptionInProgress } from "@/lib/episode";
import { MentionCard } from "@/types/MentionCard";
import { Alert, AlertTitle } from "@components/ui/alert";
import { Trans } from "@lingui/react/macro";
import { Volume2Icon } from "lucide-react";

type TranscriptStatusProps = {
  transcriptStatus: MentionCard["episode"]["transcript_status"];
  hasTranscript: MentionCard["episode"]["has_transcript"];
};

export default function TranscriptStatus({
  transcriptStatus,
  hasTranscript,
}: TranscriptStatusProps) {
  if (!transcriptStatus || hasTranscript) {
    return null;
  }

  const inProgress = isTranscriptionInProgress(transcriptStatus);

  if (inProgress) {
    return (
      <Alert variant="blue" className="my-1 items-start">
        <Volume2Icon />
        <AlertTitle>
          <Trans>
            Vi lyssnar fortfarande på det här avsnittet. Om vi upptäcker ett
            omnämnande kan du spela upp det snart.
          </Trans>
        </AlertTitle>
      </Alert>
    );
  }

  return null;
}
